/* jshint esversion: 6 */
/* jshint esversion: 11 */
/* jshint ignore:start */
import React, { useContext, useEffect, useRef, useState } from 'react';
import { MyContext } from '../../Context/MyProvider';
import Dphoto from "../../Images/profile-default.png";
import { showTost } from '../../showTost';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import secureLocalStorage from 'react-secure-storage';
const Profile = () => {

  const { t } = useTranslation();

  const { BaseUrl, setIsLogin, isLogin } = useContext(MyContext);

  const [Data, setData] = useState();
  const [profilePic, setProfilePic] = useState();
  const [selectedFile, setSelectedFile] = useState(null);
  const [isShow, setIsShow] = useState(false);

  const InputRef = useRef();

  useEffect(() => {
    window.scrollTo(0, 0);
    const LoginData = secureLocalStorage.getItem("LoginData");

    if (LoginData) {

      const { name, password, email, mobile, ccode, pro_pic } = JSON.parse(LoginData);

      setData({ name, password, email, mobile: ccode + mobile });

      if (pro_pic) {
        setProfilePic(BaseUrl + pro_pic);
      } else {
        setProfilePic(Dphoto);
      }
    }
  }, [isLogin]);

  const HandleUpdate = () => {

    const Userid = secureLocalStorage.getItem("Userid");

    if (!Data.name) {
      showTost(t("Please Enter Details !!"), "error");
      return;
    }

    if (!Data.password) {
      showTost(t("Please Enter Details !!"), "error");
      return;
    }

    axios.post(`${BaseUrl}user_api/u_profile_edit.php`, { uid: Userid, name: Data.name, password: Data.password })
      .then((res) => {
        // console.log("u_profile_edit", res);
        const toastType = res?.data?.ResponseCode === '200' ? 'success' : 'error';
        showTost(res?.data?.ResponseMsg, toastType);
        secureLocalStorage.setItem("LoginData", JSON.stringify(res.data.UserLogin));
        setIsLogin("123");
      })
      .catch((error) => {
        console.error("u_profile_edit", error);
      });
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => setSelectedFile(reader.result.split(',')[1]);
      reader.readAsDataURL(file);
    }
  };

  const HandleAddPhoto = () => {
    if (!selectedFile) {
      showTost(t("Please Upload Photo !!"), "error");
      return;
    }

    const Userid = secureLocalStorage.getItem("Userid");

    axios.post(`${BaseUrl}user_api/pro_image.php`, { uid: Userid, img: selectedFile })
      .then((res) => {
        // console.log("pro_image", res);
        const toastType = res?.data?.ResponseCode === '200' ? 'success' : 'error';
        showTost(res?.data?.ResponseMsg, toastType);
        secureLocalStorage.setItem("LoginData", JSON.stringify(res.data.UserLogin));
        setIsLogin("123");
        setIsShow(false);
      })
      .catch((error) => {
        console.error("pro_image", error);
      });
  };

  return (
    <div className='width_container'>
      <div className="mt-[20px]">
        <div className="profile">

          <div className="profile_pic">
            <img src={profilePic} className='w-[100%] h-[100%] object-cover rounded-[100%]' alt="" />
            <div onClick={() => setIsShow(true)} className="icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="tabler-icon tabler-icon-pencil-minus"><path d="M4 20h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4"></path><path d="M13.5 6.5l4 4"></path><path d="M16 19h6"></path></svg>
            </div>
          </div>

          <div className="mt-[20px]">
            <input type="text" value={Data?.name} onChange={(e) => setData({ ...Data, name: e.target.value })} className='w-[100%] border-[2px] py-[8px] px-[10px] rounded-[10px] focus-within:outline-gray-400 mt-[10px]' placeholder={t('Enter Name')} />
            <input type="text" value={Data?.password} onChange={(e) => setData({ ...Data, password: e.target.value })} className='w-[100%] border-[2px] py-[8px] px-[10px] rounded-[10px] focus-within:outline-gray-400 mt-[10px]' placeholder={t('Enter Password')} />
            <input disabled type="text" value={Data?.email} className='w-[100%] border-[2px] py-[8px] px-[10px] rounded-[10px] focus-within:outline-gray-400 mt-[10px]' />
            <input disabled type="text" value={Data?.mobile} className='w-[100%] border-[2px] py-[8px] px-[10px] rounded-[10px] focus-within:outline-gray-400 mt-[10px]' />
          </div>

          <button onClick={HandleUpdate} className='button'>{t("Update")}</button>

        </div>
      </div>

      {isShow && <div onClick={() => setIsShow(false)} className="px-[15px] py-[15px] w-full h-full fixed top-0 left-0 flex items-center justify-center bg-black bg-opacity-50 z-[999]">
        <div onClick={(e) => e.stopPropagation()} className="w-[25%] max-_430_:w-[100%] max-_768_:w-[80%] max-_1030_:w-[40%] max-_1500_:w-[30%] bg-white rounded-[15px] px-[15px] py-[10px]">
          <div className="flex flex-col justify-center items-center text-center">
            <div onClick={() => InputRef.current.click()} className="w-[138px] cursor-pointer border-[2px] border-dotted p-[10px] border-gray-400 rounded-full">
              <div className="bg-[#e5e5e5] flex items-center justify-center h-[115px] rounded-full">
                {selectedFile
                  ? <img src={`data:image/png;base64,${selectedFile}`} className="w-[100%] h-[100%] rounded-full object-center" alt="" />
                  : <h2 className="m-0 font-[400] text-[30px]">+</h2>}

                <input ref={InputRef} onChange={(e) => handleImageChange(e)} className="hidden" type="file" accept="image/*" />
              </div>
            </div>
            <div className="mt-[15px]">
              <h3 className='font-bold text-[20px]'>{t("Add Your Favorite Photo")}</h3>
            </div>
            <button onClick={HandleAddPhoto} className="button">{t("Upload")}</button>
          </div>
        </div>
      </div>}
    </div >
  )
}

export default Profile
/* jshint ignore:end */